import React from 'react';
import PropTypes from 'prop-types';
import ListTableToolbar from './ListTableToolbar';
import ListTable from './ListTable';
import BreadCrumbs from '../BreadCrumbs';

const ListPage = ({
  title,
  onAdd,
  onSearch,
  onRefresh,
  loading,
  data,
  onTableChange,
  pagination,
  columns,
  rowKey,
  breadCrumbItems,
  hideAddAction,
  showHasFilter,
  hasRushFilter = false,
  setHasRushStatusFilter,
}) => {
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              {/* Table Header */}
              <ListTableToolbar
                title={title}
                onAdd={onAdd}
                onRefresh={onRefresh}
                onSearch={onSearch}
                hideAddAction={hideAddAction}
                showHasFilter={showHasFilter}
                hasRushFilter={hasRushFilter}
                setHasRushStatusFilter={setHasRushStatusFilter}
              />

              {/* /Table Content */}
              <ListTable
                columns={columns}
                data={data}
                loading={loading}
                pagination={pagination}
                onTableChange={onTableChange}
                rowKey={rowKey}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ListPage.propTypes = {
  ...ListTableToolbar.propTypes,
  ...ListTable.propTypes,
  breadCrumbItems: PropTypes.array,
  showHasFilter: PropTypes.bool,
  hasRushFilter: PropTypes.bool,
  setHasRushStatusFilter: PropTypes.func,
};

export default ListPage;
